import HeroImageSectionAdapter from "./HeroImageSection";

export default HeroImageSectionAdapter;
